<template>
    <kt-row style="padding-right: 25px;display: block" v-if="all_services">
        <div v-for="(service,index) in all_services" v-bind:key="index">
            <kt-row>
                <kt-col lg="4" md="4" sm="6" xs="12" style="margin-top: 34px">
                    <p>
                        {{ $t('application.services.' + services[index]) }}
                    </p>
                  <span v-if="services[index] === 'iban_to_account'">
                    <!-- Your extra content here -->
                    (ست پی = استعلام شبا)
                  </span>
                </kt-col>
                <kt-col lg="2" md="2" sm="6" xs="12">
                    <kt-form-group ref="bank">
                        <kt-form-label for="provider">
                            {{ $t('application.provider') }}
                        </kt-form-label>
                        <kt-form-select size="5" id="provider" class="form-control"
                                        :name="service + '_provider'"
                                        v-model="service_wages[service].provider"
                        >
                            <option value=""></option>
                            <option
                                v-bind:key="service"
                                v-for="provider in getServiceProviders(service)"
                                v-bind:value="provider"
                            >
                                {{ providerTypeStr.get(provider) }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col  lg="3" md="3" sm="6" xs="12">
                    <kt-form-group>
                        <kt-form-label :for="service">
                            {{ $t('application.company_wage') }} (ریال)
                        </kt-form-label>
                        <kt-form-control dir="ltr" :name="service+'_company_wage'" type="number"
                                         :id="service"
                                         v-model="service_wages[service].company_wage"
                                         :disabled="!service_wages[service].provider"
                        ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col  lg="3" md="3" sm="6" xs="12">
                    <kt-form-group>
                        <kt-form-label :for="service">
                            {{ $t('application.provider_wage') }} (ریال)
                        </kt-form-label>
                        <kt-form-control dir="ltr" :name="service+'_provider_wage'" type="number"
                                         :id="service"
                                         v-model="service_wages[service].provider_wage"
                                         :disabled="!service_wages[service].provider"
                        ></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <hr>
        </div>
    </kt-row>
</template>

<script>
import {applicationServiceStatus, services, providerTypeStr} from '@/constants/openBanking'

export default {
    props: {
        all_services: {
            required: true,
        },
        service_wages: {
            required: true,
        },
        service_providers: {
            required: true,
        },
    },
    mounted() {
    },
    methods: {
        getServiceProviders(service) {
            return Object.keys(this.service_providers[service])
        },

    },
    data() {
        return {
            applicationServiceStatus,
            services,
            providerTypeStr
        }
    }
}
</script>

<style>

</style>